import React, { FC } from 'react';
import { openSidePanel } from '@alfa-bank/newclick-core/window-utils';
import { OpenSidePanelsParams } from '@alfa-bank/newclick-types/open-side-panel-params';

import { GenericWrapper } from '@alfalab/core-components/generic-wrapper';
import { PureCell } from '@alfalab/core-components/pure-cell';
import { Typography } from '@alfalab/core-components/typography';
import { InformationCircleMIcon } from '@alfalab/icons-glyph/InformationCircleMIcon';

import { TextInform } from '#/src/shared/components/alternative-login/text';

export const ButtonInform: FC = () => {
    const onInformModalOpen = () => {
        openSidePanel({
            sidePanelId: 'Inform',
        } as unknown as OpenSidePanelsParams);
    };

    return (
        <PureCell
            dataTestId='purecell'
            type='button'
            verticalPadding='default'
            onClick={onInformModalOpen}
        >
            <GenericWrapper alignItems='center'>
                <GenericWrapper padding={{ right: 'xs' }}>
                    <InformationCircleMIcon fill='#0E0E0E' />
                </GenericWrapper>
                <GenericWrapper>
                    <GenericWrapper column={true}>
                        <Typography.Text view='primary-medium' weight='medium' color='primary'>
                            {TextInform.howYouCanLogin}
                        </Typography.Text>
                    </GenericWrapper>
                </GenericWrapper>
            </GenericWrapper>
        </PureCell>
    );
};
